import { render, staticRenderFns } from "./soreness.vue?vue&type=template&id=b1f8a364&"
import script from "./soreness.vue?vue&type=script&lang=js&"
export * from "./soreness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f8a364')) {
      api.createRecord('b1f8a364', component.options)
    } else {
      api.reload('b1f8a364', component.options)
    }
    module.hot.accept("./soreness.vue?vue&type=template&id=b1f8a364&", function () {
      api.rerender('b1f8a364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/soreness.vue"
export default component.exports